import React from 'react';

import Chip, { ChipProps } from 'app/ui-kit/components/Chip';
import ProtectedData, { isProtectedData, Primitive, ProtectedDataProps } from 'pages/item/v2/components/ProtectedData';

interface Props extends ChipProps {
    data: Primitive;
    label: ChipProps['label'] | ProtectedDataProps['children'];
}

const ProtectedChip: React.FC<Props> = ({ data, label, tooltip, onClick, clickable, ...props }) => {
    const isProtected = isProtectedData(data);
    return (
        <Chip
            {...props}
            clickable={isProtected ? false : clickable}
            label={<ProtectedData data={data}>{label}</ProtectedData>}
            onClick={isProtected ? undefined : onClick}
            tooltip={isProtected ? undefined : tooltip}
        />
    );
};

export default ProtectedChip;
